<template>
    <div>
        <News-List :data='Notice'/>
        <Pagination 
        :pageNo="naml.page" 
        :pageSize='naml.limit' 
        :total="Notice.total" 
        :continues="5"
        @getPageNo='getPageNo'
        />
    </div>
</template>

<script>
import {mapState} from 'vuex'
import NewsList from '@/components/pc/NewsList'
export default {
  data() {
    return {
        naml:{
          class_id:6,
          limit:6,
          page:1,
        },
    }
  },
    components:{
      NewsList
    } ,
    activated() {
        this.postNews(this.naml)
    },
    computed:{
        ...mapState({
            Notice:state=>state.share.Notice
        })
    },
    methods: {
        getPageNo(id){
            this.naml.page=id;
            this.postNews(this.naml)
        },
        postNews(naml){
            this.$store.dispatch('PostNews',naml);
        }
    },
}
</script>

<style>

</style>